// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LdBnZ","footer":"styles_footer__2UdTb"};